module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAACWTY9zAAAAAXNSR0IArs4c6QAAAVRJREFUSA3tl8tKw0AUhv9JO814Sc2YVGKr1Np6ARFXKoigi4Kg4lrciStx51JKnycPpxvdVuJMZcBSWzKRzATpgXDgXJhvfk7CCcFumOBiC2SxgiIZETAJWBnotkEOosKwfYMpnBYHLrdBfKYi1vwomMSgDnDeAg4bIESm7dg4mOJoeMDVDkhtQUWM+slgEsMR6dMmcLIOUhJKGrTpYApEqnYtZq9eVZHcfTowiSErj9aAsw0QWsodTB6Q6DxxHCcmzOzgaOg8A9MQa1g6U+zfKCbWCj37fP/A4PVNrylDdeoPrBzGu+oyHv0QzMl/NFMp1qEu+mGEPXcuw92ztUwFk8kHodD9UgBqeAWaCLbvMvSDVWxW3GxX/mPXGBgTyjzxGm49LrYeOYJ2bATsmM2jF0SoU/s/JkMwT7xlz3wFN55vR55fTi13eYCXZhthAVT6yfcFPpWQGUP9WzAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Kuwait.png
// module id = 477
// module chunks = 7